import Header from "../../components/layout/Header";
import Footer from "../../components/layout/Footer";
import SEO from "../../components/SEO";
import { SITE_URL } from "../../config/site";
import "./LegalPages.css";

export default function PrivacyPage() {
  return (
    <>
      <SEO
        title="Política de privacidad | Imalandia"
        description="Consulta cómo Imalandia trata los datos personales relacionados con pedidos, contacto y compras de productos personalizados."
        canonical={`${SITE_URL}/privacidad`}
      />

      <Header />

      <main className="legal-page">
        <div className="legal-container">
          <p className="legal-eyebrow">PRIVACIDAD</p>
          <h1>Política de privacidad</h1>

          <div className="legal-content">
            <p>Última actualización: 30 de julio de 2026.</p>

            <h2>1. Responsable del tratamiento</h2>

            <p>
              Responsable: imalandia.com.
              <br />
              Correo de contacto:{" "}
              <a href="mailto:info@imalandia.com">info@imalandia.com</a>.
              <br />
              Teléfono: <a href="tel:+34646273415">646 273 415</a>.
            </p>

            <h2>2. Datos que se tratan</h2>

            <p>Según el servicio utilizado, pueden tratarse:</p>

            <ul>
              <li>Nombre, apellidos, correo electrónico y teléfono.</li>
              <li>Dirección de envío y datos necesarios para la facturación.</li>
              <li>
                Productos, importes, estado del pedido, incidencias y
                comunicaciones.
              </li>
              <li>
                Fotografías, textos y opciones de personalización aportados para
                producir el pedido.
              </li>
              <li>
                Datos técnicos y de seguridad necesarios para el funcionamiento
                del sitio.
              </li>
            </ul>

            <p>
              Imalandia no recibe ni almacena los datos completos de la tarjeta.
              El pago se procesa mediante Stripe.
            </p>

            <h2>3. Finalidades y bases jurídicas</h2>

            <ul>
              <li>
                Gestionar la compra, el pago, la personalización, el envío y la
                atención posterior, sobre la base de la ejecución del contrato.
              </li>
              <li>
                Atender consultas y solicitudes, sobre la base de las medidas
                precontractuales solicitadas o del consentimiento.
              </li>
              <li>
                Cumplir obligaciones fiscales, contables, de consumo y otras
                obligaciones legales.
              </li>
              <li>
                Prevenir fraude, abusos y problemas de seguridad sobre la base
                del interés legítimo, sin perjudicar los derechos del usuario.
              </li>
            </ul>

            <p>
              Los datos no se utilizarán para enviar publicidad sin una base
              jurídica que lo permita.
            </p>

            <h2>4. Destinatarios y proveedores</h2>

            <p>
              Los datos solo se comunican cuando es necesario para prestar el
              servicio o cumplir la ley. Pueden acceder a ellos:
            </p>

            <ul>
              <li>Stripe, para procesar y verificar el pago.</li>
              <li>Empresas de transporte, para entregar el pedido.</li>
              <li>
                Proveedores de alojamiento, correo y soporte tecnológico,
                sujetos a las obligaciones correspondientes.
              </li>
              <li>Administraciones públicas cuando exista obligación legal.</li>
            </ul>

            <p>Los datos personales no se venden a terceros.</p>

            <h2>5. Transferencias internacionales</h2>

            <p>
              Si un proveedor trata datos fuera del Espacio Económico Europeo,
              se aplicarán las garantías exigidas por la normativa, como una
              decisión de adecuación o cláusulas contractuales tipo.
            </p>

            <h2>6. Conservación</h2>

            <p>
              Los datos se conservan durante el tiempo necesario para gestionar
              el pedido y las incidencias. Después se mantienen bloqueados
              durante los plazos legales aplicables. Las fotografías y archivos
              de personalización se conservan únicamente mientras resulten
              necesarios para producir el pedido, resolver incidencias o atender
              responsabilidades.
            </p>

            <h2>7. Derechos</h2>

            <p>
              Puede solicitar el acceso, rectificación, supresión, oposición,
              limitación o portabilidad de sus datos escribiendo a{" "}
              <a href="mailto:info@imalandia.com">info@imalandia.com</a> con el
              asunto “Protección de datos”. Puede pedirse información adicional
              para comprobar la identidad del solicitante.
            </p>

            <p>
              Si considera que el tratamiento no se ajusta a la normativa,
              puede presentar una reclamación ante la Agencia Española de
              Protección de Datos.
            </p>

            <h2>8. Seguridad</h2>

            <p>
              Se aplican medidas técnicas y organizativas destinadas a proteger
              los datos frente a pérdida, alteración, acceso o divulgación no
              autorizados.
            </p>

            <h2>9. Cookies y almacenamiento técnico</h2>

            <p>
              El sitio no utiliza cookies de análisis, publicidad o seguimiento.
              Solo emplea almacenamiento o tecnologías técnicas necesarias para
              funciones como conservar el carrito, las preferencias esenciales
              y la seguridad del proceso de compra.
            </p>

            <h2>10. Menores de edad</h2>

            <p>
              Los servicios no se dirigen a menores de edad. Si se detectan
              datos facilitados por un menor sin autorización, se eliminarán
              cuando corresponda.
            </p>

            <h2>11. Cambios y contacto</h2>

            <p>
              Esta política puede actualizarse para reflejar cambios legales o
              técnicos. Para cualquier consulta relacionada con privacidad,
              escriba a{" "}
              <a href="mailto:info@imalandia.com">info@imalandia.com</a>.
            </p>
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
}
